import {
  CAREERS_URL,
  CASE_STUDIES_URL,
  CWS_URL,
  DATA_SECURITY_URL,
  FEEDBACK_URL,
  FETC_URL,
  GDPR_URL,
  HOW_TO_URL,
  HUB_URL,
  LOOPS_URL,
  MOTECE_URL,
  MOTECON_2021_URL,
  MOTECON_URL,
  PLEDGE_URL,
  PRESS_URL,
  STATUS_URL,
  SUBPROCESSOR_URL,
  SUCCESS_STORIES_URL,
  TAW_URL,
  TERMS_URL,
  WEATHERS_URL
} from './constants'

export const routeExternalURLMapping = {
  '/careers': CAREERS_URL,
  '/case-studies': CASE_STUDIES_URL,
  '/chrome': CWS_URL,
  '/privacy/security': DATA_SECURITY_URL,
  '/security': DATA_SECURITY_URL,
  '/feedback': FEEDBACK_URL,
  '/fetc': FETC_URL,
  '/gdpr': GDPR_URL,
  '/how-to': HOW_TO_URL,
  '/the-hub': HUB_URL,
  '/loops': LOOPS_URL,
  '/motece': MOTECE_URL,
  '/motecon-2021': MOTECON_2021_URL,
  '/motecon': MOTECON_URL,
  '/pledge': PLEDGE_URL,
  '/privacycenter': PLEDGE_URL,
  '/press': PRESS_URL,
  '/status': STATUS_URL,
  '/subprocessors': SUBPROCESSOR_URL,
  '/success-stories': SUCCESS_STORIES_URL,
  '/taw': TAW_URL,
  '/tos': TERMS_URL,
  '/terms': TERMS_URL,
  '/impact': WEATHERS_URL
}
